export default __webpack_public_path__ + "static/media/Caro1.905e7615.jpg";